import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Storylet from 'components/Storylet';
import { IAppState } from "types/app";
import { IStorylet } from "types/storylet";

export interface Props {
  storylets: IStorylet[] | null,
}

function StoryletStagger({ storylets }: Props) {
  if (storylets === null) {
    return null;
  }

  return (
    <Fragment>
      {storylets!.map(storylet => (
        <Storylet key={storylet.id} data={storylet} />
      ))}
    </Fragment>
  );
}

StoryletStagger.displayName = 'StoryletStagger';

const mapStateToProps = ({ storylet }: IAppState) => ({ storylets: storylet.storylets });

export default connect(mapStateToProps)(StoryletStagger);